import RemoveContentMargin from './RemoveContentMargin';
import RemoveContentMarginContainer from './RemoveContentMargin.container';

export default RemoveContentMarginContainer(RemoveContentMargin);
